import { render } from "./BecomeDealerForm.vue?vue&type=template&id=d360a3fe&ts=true"
import script from "./BecomeDealerForm.vue?vue&type=script&lang=ts"
export * from "./BecomeDealerForm.vue?vue&type=script&lang=ts"

import "./BecomeDealerForm.vue?vue&type=style&index=0&id=d360a3fe&lang=scss"

import exportComponent from "/Users/lorenzoli/ForkHome/marlu/marlu-store-locator-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__